<template>
  <div class="section-category section-bg">
    <div class="inner-note set-permission-staff">
      <h3><translate>Set price for</translate> "{{ article.name }}"</h3>
      <input-pad
        :item="this"
        :property="'price'"
        :attributes="{
            'class': 'set-permission-staff'
          }"/><br>
      <div class="variable-price">
        <div>
          <span translate>Price Min</span>
          <span>{{ priceMin | currency }}</span>
        </div>
        <div>
          <span translate>Price Max</span>
          <span>{{ priceMax | currency }}</span>
        </div>
      </div>
      <div class="btns-footer mt-3">
        <button ref="confirm" class="btn btn-primary" @click="onConfirm" v-translate>Confirm</button>
        <button class="btn btn-cancel" @click="onCancel" v-translate>Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';
export default {
  name: 'VariablePrice',
  props: ['article'],
  data() {
    return {
      price: null
    };
  },
  computed: {
    clone() { return this.$store.getters.getArticleClone(this.article) },
    priceMin() {
      return this.clone ? this.clone.priceMin : this.article.priceMin;
    },
    priceMax() {
      return this.clone ? this.clone.priceMax : this.article.priceMax;
    },
  },
  methods: {
    async onConfirm() {
      if(!this.price) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Please enter Price'));
        return;
      } else if(this.price < this.priceMin
                || this.price > this.priceMax) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Price must be greater than min price and less than max price'));
        return;
      }
      const article = Object.assign({}, this.article);
      article.price = this.price;
      this.$store.getters.addArticle(article);
      this.$router.push('order');
    },
    onCancel() {
      this.$router.push('order');
    }
  },
  created() {
    if (!this.article) {
      this.$router.push('order');
    }
  },
};
</script>
